/* eslint-disable max-len */
import { MouseEvent, useEffect } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import Skeleton from '@/components/common/Skeleton/Skeleton';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { useGetCustomerName } from './useGetCustomerName';

interface IFilteredByCustomerBreadcrumb {
  defaultText: string;
  path: string;
}

export default function NewContractsFilteredByCustomerBreadcrumb({
  defaultText,
  path,
}: IFilteredByCustomerBreadcrumb) {
  const history = useHistory();
  const parentCustomerId = new URL(window.location.href).searchParams.get('parentCustomerId') ?? '';
  const parentAccountNumber = new URL(window.location.href).searchParams.get('parentAccountNumber') ?? '';
  const { customerName, error, getCustomerName, isLoading } = useGetCustomerName();

  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    const pathName = new URL(window.location.href).pathname;

    const isGridFilteredByParentCustomerPage = matchPath(pathName, {
      path: path,
      exact: true,
    });

    if (isGridFilteredByParentCustomerPage) {
      window.location.reload();
    }
    else {
      const link = getParameterizedLink(
        `${path}?parentCustomerId=${parentCustomerId}&parentAccountNumber=${parentAccountNumber}`);
      history.push(link);
    }
  };

  useEffect(() => {
    if (parentCustomerId) {
      getCustomerName(parentCustomerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentCustomerId]);


  if (isLoading) {
    return <Skeleton width={100} />;
  }

  if (error || !customerName) {
    return <>{defaultText}</>;
  }

  return (
    <a
      onClick={onClick}
      href={window.location.href}
    >
      {`Contracts searched by customer: ${customerName}`}
    </a>
  );
}
